import {
    Component
} from "../../../../../../sedestral/framework/interface/component/Component";
import {
    LoaderLightComponent
} from "../../../../../components/global/loader/light/LoaderLightComponent";
import {SiteService} from "../../../../../../services/site/SiteService";
import {
    VisualSelectBoxComponent
} from "../../../../../components/global/selectbox/VisualSelectBoxComponent";
import {Resources} from "../../../../../../resources/Resources";
import {CountryIconComponent} from "../../country/CountryIconComponent";
import * as s from "./site-tax.scss";
import {ISiteTaxModel} from "../../../../../../models/site/address/tax/ITaxTypeModel";
import {EntityService} from "../../../../../../services/entity/EntityService";

export class SiteTaxComponent extends Component {

    public taxes: ISiteTaxModel[];
    public selectBox: VisualSelectBoxComponent;

    constructor() {
        super();
        //language=HTML
        this.template = `
            <div class="${s.componentSiteTax}">
                ${this.draw(new LoaderLightComponent())}
            </div>
        `;
    }

    commit() {
        this.init();
        super.commit();
    }

    async init() {
        this.taxes = await SiteService.getTaxTypes(this);
        let entries = [];
        let selectedValue: number;

        this.taxes.forEach(value => {
            let country = Resources.countryFrom(value.country);

            entries.push({
                value: value.id,
                label: (country ? `<div class="${s.componentSiteTaxIcon}">${this.draw(new CountryIconComponent(country.a3))}</div> ` : ``) + value.label,
                description: country?.n ?? value.country
            });

            if (EntityService.activeSite.address?.tax?.type) {
                selectedValue = EntityService.activeSite.address?.tax?.type;
            } else if (country?.a2 == (EntityService.activeSite.address?.country ?? Resources.getCountryCode())) {
                selectedValue = value.id;
            }
        })

        this.clearAll();
        this.selectBox = new VisualSelectBoxComponent({
            search: true,
            searchDescription: true,
            entries: entries,
            selectedValue: selectedValue
        });
        this.selectBox.onSelect = () => this.onTaxChange(this.getSelectedTax());
        this.render(this.selectBox);

        const selectedTax = selectedValue
            ? this.taxes.find(value => value.id == selectedValue)
            : this.taxes[0];
        if (selectedTax) {
            this.onTaxChange(selectedTax);
        }
    }

    selectByCountry(countryCode: string) {
        if (!this.taxes || !this.selectBox) {
            return;
        }

        const matchingTax = this.taxes.find(tax => {
            const country = Resources.countryFrom(tax.country);
            return country?.a2 == countryCode;
        });

        if (matchingTax) {
            this.selectBox.select(matchingTax.id + "", true);
            this.onTaxChange(matchingTax);
        }
    }

    getSelectedTax(): ISiteTaxModel {
        return this.taxes.find(value => value.id == this.selectBox.getSelection().value);
    }

    onTaxChange(tax: ISiteTaxModel) {

    }

}